module.exports = __webpack_public_path__ + "assets/images/small-multiples/mobile.svg?v=49292020";